export default __webpack_public_path__ + "static/launch-906e74a1f5dc1bee185cf9752ce33cad.jpg";